import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const ProductRoute = [
    {
        path: '/product',
        component: React.lazy(() => import('./Products.js')),
        auth: AuthRoles.editor,
    }
]

export default ProductRoute;